/* src/routes/blog/3d-printer-wip-leaking.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";

function create_default_slot_4(ctx) {
	let p;
	let t0;
	let t1;
	let gallery;
	let current;

	gallery = new Gallery({
			props: { images: /*photos_toohot*/ ctx[2] }
		});

	return {
		c() {
			p = element("p");
			t0 = text("While trying to calibrate my hot end I set my extruder speed too high\n      which meant that the plastic was being pushed into the hot end faster than\n      it could be extruded.");
			t1 = space();
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "While trying to calibrate my hot end I set my extruder speed too high\n      which meant that the plastic was being pushed into the hot end faster than\n      it could be extruded.");
			p_nodes.forEach(detach);
			t1 = claim_space(nodes);
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			insert(target, t1, anchor);
			mount_component(gallery, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p);
			if (detaching) detach(t1);
			destroy_component(gallery, detaching);
		}
	};
}

// (42:6) <LinkExternal href="http://reprap.org/wiki/PLA">
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("PLA");
		},
		l(nodes) {
			t = claim_text(nodes, "PLA");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (44:6) <LinkExternal href="http://reprap.org/wiki/Jhead">
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("JHead");
		},
		l(nodes) {
			t = claim_text(nodes, "JHead");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (39:2) <PostSection title="Back in business">
function create_default_slot_1(ctx) {
	let p;
	let t0;
	let linkexternal0;
	let t1;
	let linkexternal1;
	let t2;
	let t3;
	let gallery;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "http://reprap.org/wiki/PLA",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "http://reprap.org/wiki/Jhead",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	gallery = new Gallery({
			props: {
				images: /*photos_back_in_business*/ ctx[3]
			}
		});

	return {
		c() {
			p = element("p");
			t0 = text("After taking it apart I found that it was due to the inner\n      ");
			create_component(linkexternal0.$$.fragment);
			t1 = text("\n      of the\n      ");
			create_component(linkexternal1.$$.fragment);
			t2 = text("\n      slipping a bit inside. I have now reconstructed the hot end and its clean\n      and tight.");
			t3 = space();
			create_component(gallery.$$.fragment);
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "After taking it apart I found that it was due to the inner\n      ");
			claim_component(linkexternal0.$$.fragment, p_nodes);
			t1 = claim_text(p_nodes, "\n      of the\n      ");
			claim_component(linkexternal1.$$.fragment, p_nodes);
			t2 = claim_text(p_nodes, "\n      slipping a bit inside. I have now reconstructed the hot end and its clean\n      and tight.");
			p_nodes.forEach(detach);
			t3 = claim_space(nodes);
			claim_component(gallery.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			mount_component(linkexternal0, p, null);
			append(p, t1);
			mount_component(linkexternal1, p, null);
			append(p, t2);
			insert(target, t3, anchor);
			mount_component(gallery, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 16) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 16) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p);
			destroy_component(linkexternal0);
			destroy_component(linkexternal1);
			if (detaching) detach(t3);
			destroy_component(gallery, detaching);
		}
	};
}

// (26:0) <PostContents>
function create_default_slot(ctx) {
	let postsection0;
	let t;
	let postsection1;
	let current;

	postsection0 = new PostSection({
			props: {
				title: "Too Hot",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	postsection1 = new PostSection({
			props: {
				title: "Back in business",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection0.$$.fragment);
			t = space();
			create_component(postsection1.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postsection1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection0, target, anchor);
			insert(target, t, anchor);
			mount_component(postsection1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection0_changes = {};

			if (dirty & /*$$scope*/ 16) {
				postsection0_changes.$$scope = { dirty, ctx };
			}

			postsection0.$set(postsection0_changes);
			const postsection1_changes = {};

			if (dirty & /*$$scope*/ 16) {
				postsection1_changes.$$scope = { dirty, ctx };
			}

			postsection1.$set(postsection1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection0.$$.fragment, local);
			transition_in(postsection1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection0.$$.fragment, local);
			transition_out(postsection1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection0, detaching);
			if (detaching) detach(t);
			destroy_component(postsection1, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 16) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "3D Printer 2 - Leaking";
const date = "2014-01-31";

function instance($$self) {
	const tags = ["hardware", "build"];
	const projects = ["3D-Printer"];

	const photos_toohot = [
		"/content/blog/images/3d-printer-leaking/leaking.jpg",
		"/content/blog/images/3d-printer-leaking/disasembly2.jpg",
		"/content/blog/images/3d-printer-leaking/disasembly.jpg"
	];

	const photos_back_in_business = [
		"/content/blog/images/3d-printer-leaking/cleaned1.jpg",
		"/content/blog/images/3d-printer-leaking/cleaned2.jpg"
	];

	return [tags, projects, photos_toohot, photos_back_in_business];
}

class _3d_printer_wip_leaking extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default _3d_printer_wip_leaking;
//# sourceMappingURL=3d-printer-wip-leaking.svelte.js.map
